<!-- BEGIN LEFT -->
<div id="left-sidebar" class="always-on-top">
  <div id="contact-button-box">
    <a id="contact-button"  [class.active]="routeUrl&&routeUrl.startsWith('/contact')" [routerLink]="'/contact'">{{ 'CONTACT' | transloco }}</a>
  </div>
</div>
<!-- END LEFT -->
